<div class="layoutBlock">
	<div class="columnThreeQuarter">
	
		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldSetContainer></ng-template>

        <div *ngIf="!patent.priorityPatent">
        	<res-research-tab [(projects)]="patent.projects"
        		[dynamicComponent]="patent._dynamicComponent">
        	</res-research-tab>
        </div>
        <div *ngIf="patent.priorityPatent">
        	<res-priority-patent-view-projects [projects]="patent.priorityPatent.projects"></res-priority-patent-view-projects>
        </div>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldSetContainer></ng-template>

	</div>
</div>
